import { get } from 'lodash-es';
import { AxiosResponse } from 'axios';
import { message as EeveeMessage } from '@fuxi/eevee-ui';
import { handleLogout, safeToLogin } from 'common/utils';

export default function responseHandler(
  response: AxiosResponse & { code?: number; message?: string },
): ExtendAxioResponse {
  const data = get(response, 'data.data', response.data);
  const code = get(response, 'data.code', response?.code);
  const message = get(response, 'data.message', response?.message);
  if (code === 401) {
    EeveeMessage.error('请先登录');
    //用户token过期，需要重新登录
    handleLogout();
    safeToLogin();
  }

  return { ...response, data, code, message };
}
